import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NavigationExtras } from '@angular/router';

import { Subject } from 'rxjs';

import {
    FormTagListActionItem,
    FormTagListActionItemLocation,
    FormTagListStyling,
    GenerateStructuredQueryFromGlobalSearchTerm,
    UrlQueryParamsConverter
} from '@stylehaven/components';

@Component({
    standalone: false,
    selector: 'digihaven-dashboard-search',
    templateUrl: './dashboard-search.component.html'
})
export class DashboardSearchComponent implements OnInit, OnDestroy {
    readonly destroy$: Subject<void> = new Subject<void>();

    @Input() placeholderMsg!: string;
    @Output() searchChanged: EventEmitter<NavigationExtras> = new EventEmitter();

    recordSearchBarForm!: UntypedFormControl;
    recordSearchBarActionItem!: FormTagListActionItem;
    recordSearchBarStyling!: FormTagListStyling;

    ngOnInit(): void {
        this.initSearchDashboard();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private initSearchDashboard(): void {
        this.recordSearchBarStyling = {
            style: 'Embedded',
            modifiers: [],
            truncate: true
        };

        this.recordSearchBarForm = new UntypedFormControl();
        this.recordSearchBarActionItem = new FormTagListActionItem(FormTagListActionItemLocation.Joined, 'search');
        this.recordSearchBarActionItem.eventListener = () => this.onSearch();

        this.performSearchOnValueChange();
    }

    private performSearchOnValueChange(): void {
        this.recordSearchBarForm.valueChanges.subscribe((keywords: string[]) => {
            if (keywords.length > 0) {
                this.onSearch();
            }
        });
    }

    private onSearch(): void {
        const navExtras: NavigationExtras = {
            queryParams: UrlQueryParamsConverter.generateQueryParams(
                GenerateStructuredQueryFromGlobalSearchTerm(this.recordSearchBarForm.value)
            )
        };
        this.searchChanged.emit(navExtras);
    }
}
